module.exports = __webpack_public_path__ + "static/media/awoolplanet_htu04.3ebcbd23.gif";